<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import Heading  from './components/Common/Heading.vue';

export default {
  name: 'App',
  components: {
    Heading
  }
}
</script>